import React, { useState, useEffect } from 'react';

const TypewriterPlaceholder = ({ placeholders, currentPlaceholder, onComplete }) => {
  const [displayText, setDisplayText] = useState('');
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isTyping, setIsTyping] = useState(true);
  const [placeholderIndex, setPlaceholderIndex] = useState(0);

  useEffect(() => {
    if (!placeholders || placeholders.length === 0) return;
    
    const currentText = placeholders[placeholderIndex];
    
    if (isTyping) {
      // Typing animation - moderate speed
      if (currentIndex < currentText.length) {
        const timeout = setTimeout(() => {
          // Type 1-2 characters at a time for a more natural look
          const charsToAdd = Math.min(1 + Math.floor(Math.random() * 2), currentText.length - currentIndex);
          const newText = currentText.substring(currentIndex, currentIndex + charsToAdd);
          setDisplayText(prev => prev + newText);
          setCurrentIndex(prevIndex => prevIndex + charsToAdd);
        }, 50 + Math.random() * 30); // Moderate typing speed with slight variation
        
        return () => clearTimeout(timeout);
      } else {
        // Finished typing current text - moderate pause
        setIsTyping(false);
        const timeout = setTimeout(() => {
          setIsTyping(false);
        }, 1200); // Moderate pause before changing text
        
        return () => clearTimeout(timeout);
      }
    } else {
      // Skip deleting animation and just change text
      setDisplayText('');
      setIsTyping(true);
      setCurrentIndex(0);
      setPlaceholderIndex((prevIndex) => (prevIndex + 1) % placeholders.length);
      
      // Notify parent when we've cycled through all placeholders
      if (placeholderIndex === placeholders.length - 1) {
        if (onComplete) onComplete();
      }
    }
  }, [displayText, currentIndex, isTyping, placeholderIndex, placeholders, onComplete]);

  // If a current placeholder is provided, use it instead of the animated one
  return currentPlaceholder || displayText;
};

export default TypewriterPlaceholder;
